import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://rqnbazeuyulkkwxykmcp.supabase.co'
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJxbmJhemV1eXVsa2t3eHlrbWNwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzcwNDk2MDQsImV4cCI6MjA5MjYyNTYwNH0.tDB4jukTC3oedq1gM9HlRcSWjT_-z6cCixX_XBIeHt0'

export const supabase = createClient(supabaseUrl, supabaseKey)